// initial state
const state = {
  filters: {
    remember: false,
    sync: false,
  },
};

const getters = {
  rememberFilters: (state) => {
    return state.filters.remember;
  },
  syncFilters: (state) => {
    return state.filters.sync;
  },
};

const actions = {};

const mutations = {
  rememberFilters(state, value) {
    state.filters.remember = value;
  },
  syncFilters(state, value) {
    state.filters.sync = value;
  },
};

export default {
  namespaced: true,
  state: state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/userSettings.js